import api from "../index";

const adminService = {
  // Get dashboard statistics
  getDashboardStats: async (timeframe = "7days") => {
    const response = await api.get(
      `/admin/dashboard/stats?timeframe=${timeframe}`,
    );
    return response.data;
  },

  // Get recent activities
  getRecentActivities: async (limit = 10) => {
    const response = await api.get(
      `/admin/dashboard/activities?limit=${limit}`,
    );
    return response.data;
  },

  // Get sales chart data
  getSalesChartData: async (timeframe = "7days") => {
    const response = await api.get(
      `/admin/dashboard/sales-chart?timeframe=${timeframe}`,
    );
    return response.data;
  },

  // Get course performance
  getCoursePerformance: async () => {
    const response = await api.get("/admin/courses/performance");
    return response.data;
  },

  // Get revenue analytics
  getRevenueAnalytics: async (period = "monthly") => {
    const response = await api.get(`/admin/analytics/revenue?period=${period}`);
    return response.data;
  },

  // User Management
  getAllUsers: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(
      `/admin/users${queryString ? `?${queryString}` : ""}`,
    );
    return response.data;
  },

  getAllUserEmails: async () => {
    const response = await api.get("/admin/users/export/emails");
    return response.data;
  },

  getUserById: async (userId) => {
    const response = await api.get(`/admin/users/${userId}`);
    return response.data;
  },

  updateUser: async (userId, userData) => {
    const response = await api.put(`/admin/users/${userId}`, userData);
    return response.data;
  },

  deleteUser: async (userId) => {
    const response = await api.delete(`/admin/users/${userId}`);
    return response.data;
  },

  // Course Management
  getAllCourses: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(
      `/admin/courses${queryString ? `?${queryString}` : ""}`,
    );
    return response.data;
  },

  getCourseById: async (courseId) => {
    const response = await api.get(`/admin/courses/${courseId}`);
    return response.data;
  },

  createCourse: async (courseData) => {
    const response = await api.post("/admin/courses", courseData);
    return response.data;
  },

  updateCourse: async (courseId, courseData) => {
    const response = await api.put(`/admin/courses/${courseId}`, courseData);
    return response.data;
  },

  deleteCourse: async (courseId) => {
    const response = await api.delete(`/admin/courses/${courseId}`);
    return response.data;
  },

  // Order Management
  getAllOrders: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(
      `/admin/orders${queryString ? `?${queryString}` : ""}`,
    );
    return response.data;
  },

  getOrderById: async (orderId) => {
    const response = await api.get(`/admin/orders/${orderId}`);
    return response.data;
  },

  updateOrderStatus: async (orderId, data) => {
    const response = await api.put(`/admin/orders/${orderId}`, data);
    return response.data;
  },

  deleteOrder: async (orderId) => {
    const response = await api.delete(`/admin/orders/${orderId}`);
    return response.data;
  },

  importCourses: async (coursesData) => {
    const response = await api.post("/admin/courses/import", coursesData);
    return response.data;
  },

  // Promo Code Management
  getAllPromoCodes: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(
      `/admin/promo-codes${queryString ? `?${queryString}` : ""}`,
    );
    return response.data;
  },

  createPromoCode: async (promoData) => {
    const response = await api.post("/admin/promo-codes", promoData);
    return response.data;
  },

  deletePromoCode: async (promoId) => {
    const response = await api.delete(`/admin/promo-codes/${promoId}`);
    return response.data;
  },

  // Certificate Applications
  getCertificateApplicationById: async (applicationId) => {
    const response = await api.get(`/admin/certificates/${applicationId}`);
    return response.data;
  },

  // Site Settings
  updatePromoTicker: async (data) => {
    const response = await api.put("/admin/settings/promo-ticker", data);
    return response.data;
  },
};

export default adminService;
